/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NotificationScheduleDto } from "./NotificationScheduleDto";
import {
    NotificationScheduleDtoFromJSON,
    NotificationScheduleDtoFromJSONTyped,
    NotificationScheduleDtoToJSON,
} from "./NotificationScheduleDto";

/**
 *
 * @export
 * @interface NotificationPreferenceDto
 */
export interface NotificationPreferenceDto {
    /**
     *
     * @type {number}
     * @memberof NotificationPreferenceDto
     */
    notificationPreferenceId?: number;
    /**
     *
     * @type {number}
     * @memberof NotificationPreferenceDto
     */
    userAccountId?: number;
    /**
     *
     * @type {string}
     * @memberof NotificationPreferenceDto
     */
    userName?: string;
    /**
     *
     * @type {string}
     * @memberof NotificationPreferenceDto
     */
    userEmail?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof NotificationPreferenceDto
     */
    deviceGroupTags?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof NotificationPreferenceDto
     */
    deviceIdentities?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof NotificationPreferenceDto
     */
    notificationTypes?: Array<NotificationPreferenceDtoNotificationTypesEnum>;
    /**
     *
     * @type {Array<string>}
     * @memberof NotificationPreferenceDto
     */
    notificationMethods?: Array<NotificationPreferenceDtoNotificationMethodsEnum>;
    /**
     *
     * @type {string}
     * @memberof NotificationPreferenceDto
     */
    notificationFrequency?: NotificationPreferenceDtoNotificationFrequencyEnum;
    /**
     *
     * @type {NotificationScheduleDto}
     * @memberof NotificationPreferenceDto
     */
    schedule?: NotificationScheduleDto;
    /**
     *
     * @type {Date}
     * @memberof NotificationPreferenceDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof NotificationPreferenceDto
     */
    updatedAt?: Date;
}

/**
 * @export
 */
export const NotificationPreferenceDtoNotificationTypesEnum = {
    Unknown: "Unknown",
    FaultedStateDevice: "FaultedStateDevice",
    OfflineStateDevice: "OfflineStateDevice",
    UnknownStateDevice: "UnknownStateDevice",
    NonOperationalDevice: "NonOperationalDevice",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    EnergyPriceChargingResumed: "EnergyPriceChargingResumed",
    Warning: "Warning",
    FrequentFaultsWarning: "FrequentFaultsWarning",
    ShortDurationWarning: "ShortDurationWarning",
    NoActivityWarning: "NoActivityWarning",
    ZerokWhWarning: "ZerokWhWarning",
    PowerLossWarning: "PowerLossWarning",
    LowEnergyMidSessionWarning: "LowEnergyMidSessionWarning",
} as const;
export type NotificationPreferenceDtoNotificationTypesEnum =
    (typeof NotificationPreferenceDtoNotificationTypesEnum)[keyof typeof NotificationPreferenceDtoNotificationTypesEnum];

/**
 * @export
 */
export const NotificationPreferenceDtoNotificationMethodsEnum = {
    Unknown: "Unknown",
    Email: "Email",
    Sms: "SMS",
    PushNotification: "PushNotification",
} as const;
export type NotificationPreferenceDtoNotificationMethodsEnum =
    (typeof NotificationPreferenceDtoNotificationMethodsEnum)[keyof typeof NotificationPreferenceDtoNotificationMethodsEnum];

/**
 * @export
 */
export const NotificationPreferenceDtoNotificationFrequencyEnum = {
    Unknown: "Unknown",
    RealTime: "RealTime",
    Scheduled: "Scheduled",
} as const;
export type NotificationPreferenceDtoNotificationFrequencyEnum =
    (typeof NotificationPreferenceDtoNotificationFrequencyEnum)[keyof typeof NotificationPreferenceDtoNotificationFrequencyEnum];

/**
 * Check if a given object implements the NotificationPreferenceDto interface.
 */
export function instanceOfNotificationPreferenceDto(
    value: object,
): value is NotificationPreferenceDto {
    return true;
}

export function NotificationPreferenceDtoFromJSON(
    json: any,
): NotificationPreferenceDto {
    return NotificationPreferenceDtoFromJSONTyped(json, false);
}

export function NotificationPreferenceDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): NotificationPreferenceDto {
    if (json == null) {
        return json;
    }
    return {
        notificationPreferenceId:
            json["notificationPreferenceId"] == null
                ? undefined
                : json["notificationPreferenceId"],
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        userName: json["userName"] == null ? undefined : json["userName"],
        userEmail: json["userEmail"] == null ? undefined : json["userEmail"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
        deviceIdentities:
            json["deviceIdentities"] == null
                ? undefined
                : json["deviceIdentities"],
        notificationTypes:
            json["notificationTypes"] == null
                ? undefined
                : json["notificationTypes"],
        notificationMethods:
            json["notificationMethods"] == null
                ? undefined
                : json["notificationMethods"],
        notificationFrequency:
            json["notificationFrequency"] == null
                ? undefined
                : json["notificationFrequency"],
        schedule:
            json["schedule"] == null
                ? undefined
                : NotificationScheduleDtoFromJSON(json["schedule"]),
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function NotificationPreferenceDtoToJSON(
    value?: NotificationPreferenceDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        notificationPreferenceId: value["notificationPreferenceId"],
        userAccountId: value["userAccountId"],
        userName: value["userName"],
        userEmail: value["userEmail"],
        deviceGroupTags: value["deviceGroupTags"],
        deviceIdentities: value["deviceIdentities"],
        notificationTypes: value["notificationTypes"],
        notificationMethods: value["notificationMethods"],
        notificationFrequency: value["notificationFrequency"],
        schedule: NotificationScheduleDtoToJSON(value["schedule"]),
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
